import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/billing/balance';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/billing/balance`,
      { headers: getLocalUser() },
    );
    // Flask wraps payloads as {data: {...}} via responseJSON; unwrap so
    // selectors can read fields like current_balance directly.
    yield put(fetchSuccess(response.data?.data ?? response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
